import OfferStore from "./OfferStore";

const offerStore = new OfferStore();

export default offerStore;
